module.exports = __webpack_public_path__ + "img/ceuta.3b463ab4.svg";